import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { AllDashboardServiceProxy, DashboardMyTimesheetDto } from '../../../../../shared/service-proxies/service-proxies';
import { TimesheetUtilityService } from '@app/main/time-sheet-new/services/timesheet-utility.service';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AbpSessionService } from 'abp-ng2-module';
import { AppRoutes } from '@app/shared/routes/app-routes';
@Component({
    standalone: false,
    selector: 'app-dashboard-timesheet',
    templateUrl: './dashboard-timesheet.component.html',
    styleUrls: ['./dashboard-timesheet.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardTimesheetComponent extends AppComponentBase implements OnInit {
    //Array for Timesheet Records
    isLoaded = false;
    isTimesheetRecordsEmpty = true;
    dateTime = new Date();
    msg: string;
    myDashboardDetails: DashboardMyTimesheetDto[];
    constructor(private _abpSessionService: AbpSessionService, private _monitorService: MonitoringService, private _AllDashboardServiceProxy: AllDashboardServiceProxy, private router: Router, injector: Injector, public _tus: TimesheetUtilityService) {
        super(injector);
    }
    ngOnInit(): void {
        this.msg = "userId = " + this._abpSessionService.userId + "tenantId =" + this._abpSessionService.tenantId;
        this._monitorService.logPageView("UI-DashboardTimeSheet");
        this.getUserTimesheetdetails();
    }
    async getUserTimesheetdetails() {
        try {
            this._monitorService.logTrace("UI-getUserTimesheetdetails", { "getUserTimesheetdetails ": "MyTimeSheet: called " + this + this.dateTime });
            await this._AllDashboardServiceProxy.myTimesheet().subscribe(result => {
                this.myDashboardDetails = [];
                result.forEach(x => {
                    if (x.projectImage === '') {
                        x.projectImage = 'assets/common/images/new-dashboard/default-project-bag.svg';
                    }
                    this.myDashboardDetails.push(x);
                    this.isTimesheetRecordsEmpty = false;
                });
                this.isLoaded = true;
                this.markForCheck();
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    viewall() {
        this.router.navigate([AppRoutes.timesheet], { queryParams: { activeTab: 2 } });
    }
    getHrsAndMinutes(timestamp: string) {
        if (!timestamp)
            return '00h 00m';
        let hours = Math.floor(parseInt(timestamp.split(":")[0]));
        let min = parseInt(timestamp.split(":")[1]);
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min} h`;
    }
}
